
  import { Component } from 'vue-property-decorator'
  import { plainToInstance } from 'class-transformer'
  import BaseForm from '@/components/forms/view/BaseForm.vue'
  import { Form } from '@/entities/public/Resource/metadata'
  import { fixAmountFormatted, fixPrice, isValidNumber, stringifySafe } from '@/utils/general'
  import { Enablement } from '@/entities/purchase'
  import LinkedPerson from '@/components/forms/fields/LinkedPerson.vue'
  import GFiles from '@/components/core/files/GFiles.vue'
  import GRadioButton from '@/components/core/input/GRadioButton.vue'
  import GCostField from '@/components/core/input/GCostField.vue'
  import AutoResume from '@/components/forms/AutoResume.vue'
  import { Stock } from '@/entities/sales'
  import { DocumentationView } from '@/components/forms/view/DocumentationView'
  import GDatePicker from '@/components/core/input/GDatePicker.vue'
  import GAlert from '@/components/core/alert/GAlert.vue'
  import PTitle from '@/components/config/PTitle.vue'
  import GTextarea from '@/components/core/input/GTextarea.vue'
  import BackupExpenseCell from '@/components/dataTables/cell/BackupExpenseCell.vue'
  import { Deal } from '@/entities/crm'

@Component({
  components: { GAlert, GDatePicker, GCostField, GRadioButton, GFiles, LinkedPerson, BaseForm, AutoResume, PTitle, GTextarea, BackupExpenseCell },
  methods: { fixAmountFormatted, fixPrice, isValidNumber },
  computed: {},
})
  export default class StockEnablementTaskForm extends DocumentationView {
  enablement: Enablement = plainToInstance(Enablement, {})
  stock: Stock = plainToInstance(Stock, {})
  components = []
  file = []
  message = ''
  payments = []
  alert = {
    open: false,
    title: '',
    item: null,
  }

  processEnablementTaskId = null
  missingValue = ''
  lastDocument = []
  enablementTaskInspectionComponent = []

  idInspectionInspectedComponent = null
  task = null
  showDetail = false

  title = ''
  errorMessage= ''
  formData = {
    valid: null,
    comment: '',
  }

  metadata = {}
  metadataCollection = {}

  async mounted () {
    this.loadingForm = true

    await this.setMetadata()
    const { uid, id, title, metadataCollection } = this
    const taskId = uid || id

    if (isValidNumber(taskId)) {
      await this.getEnablementTaskInfo(taskId)
    }

    if (!this.isBreadCrumbPresent(title)) {
      this.setFormCrumbs(metadataCollection, title, Boolean(taskId))
    }

    this.displayDetail()
    this.loadingForm = false
  }

  async setMetadata () {
    this.loadingForm = true
    const { metadata } = this.getForm('EnablementTask', 'supervisor_enablement_task')

    const { form } = metadata as Form
    this.title = form.title
    this.metadataCollection = metadata
  }

  openFile (fileProcess) {
    fileProcess.map(file => {
      this.openLink(file.file.uri)
    })
  }

  async getEnablementTaskInfo (id) {
    if (!id) return
    this.task = await this.fetchData({
      query: { name: 'fetch', model: 'EnablementTask', params: { id } },
    })

    this.stock = await this.fetchData({
      query: { name: 'fetch', model: 'Stock', params: { id: this.task.enablement.stock.id } },
    })

    if (this.task) {
      this.enablementTaskInspectionComponent = await this.fetchData({
        query: { name: 'find', model: 'InspectionQualification' },
        filter: {
          component: {
            _and: [
              { id_process_record: { _eq: this.task.id } },
              { process: { table_name: { _eq: 'enablement_task' } } },
            ],
          },
        },
        force: true,
      })
      const idFile = this.enablementTaskInspectionComponent[0].component.id

      const process = (await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'inspection_inspected_component' } },
    }))[0]
      this.file = await this.fetchData({
      query: { name: 'find', model: 'FileProcess' },
      filter: {
        _and: [
          { id_process_record: { _eq: idFile } },
          { parameter: { process: { id: { _eq: process.id } } } },
          { parameter: { file_type: { name: { _eq: 'photo' } } } },
        ],
      },
      force: true,
      })

      await this.findPaymentOrder(this.task)
    }

    this.loadingForm = false
  }

  async findPaymentOrder (task) {
    const paymentOrder = (await this.fetchData({
      query: { name: 'find', model: 'PaymentOrder' },
      filter: {
        _and: [
          { id_process_record: { _eq: task.id } },
          { process: { table_name: { _eq: 'enablement_task' } } },
        ],
      },
      force: true,
    }))[0]

    const stock = (await this.fetchData({
      query: { name: 'find', model: 'Stock' },
      filter: { id_enablement: { _eq: task.enablement.id } },
    }))[0]

    if (this.isSupervisor) {
      await Promise.all(
        paymentOrder.payments.map(async payment => {
          const paymentData = await this.fetchData({
            query: { name: 'fetch', model: 'Payment', params: { id: payment.id } },
            force: true,
          })
          paymentData.deal.auto = stock.auto
          paymentData.paymentRecipient.paymentOrderItem = await this.fetchData({
            query: {
              name: 'fetch',
              model: 'PaymentOrderItem',
              params: { id: paymentData.paymentRecipient.paymentOrderItem.id },
            },
            force: true,
          })
          this.payments.push(paymentData)
        }),
      )
    } else {
      await Promise.all(
        paymentOrder.payments.map(async payment => {
          const paymentData = await this.fetchData({
            query: { name: 'fetchInspector', model: 'Payment', params: { id: payment.id } },
            force: true,
          })
          paymentData.deal = plainToInstance(Deal, {})
          paymentData.deal.auto = stock.auto
          paymentData.paymentRecipient.paymentOrderItem = await this.fetchData({
            query: {
              name: 'fetch',
              model: 'PaymentOrderItem',
              params: { id: paymentData.paymentRecipient.paymentOrderItem.id },
            },
            force: true,
          })
          this.payments.push(paymentData)
        }),
      )
    }
  }

  displayDetail () {
    const { task, metadataCollection } = this

    this.metadata = {
      data: task,
      metadata: metadataCollection,
    }

    this.showDetail = Boolean(task.id)
  }

  async send () {
    const inValidComment = this.formData.comment?.length > 256
    if (!this.$refs.form.validate() || inValidComment) {
      this.$refs.form.validate()
      return
    }

    this.loadingForm = true

    await this.validateEnablementTask(this)
    this.loadingForm = false
    await this.close()
  }

  get inspectionComponent () {
    const { enablementTaskInspectionComponent } = this

    return enablementTaskInspectionComponent
  }

  get change () {
    const { formData, loadingForm } = this

    return stringifySafe([formData, loadingForm])
  }

  get disabledSend () {
    const { task } = this
    return Boolean(task?.status?.active || task?.closingReason?.id || task?.status?.isToUpdating)
  }

  get disableFields () {
    const { task } = this

    return Boolean(task?.closingReason?.id)
  }
  }
